var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0F753C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0426 111V41.1818H91.4517V51.7841H58.6903V70.7386H89.0994V81.3409H58.6903V100.398H91.7244V111H46.0426ZM104.355 41.1818H119.832L140.56 91.7727H141.378L162.105 41.1818H177.582V111H165.446V63.0341H164.798L145.503 110.795H136.435L117.139 62.9318H116.491V111H104.355V41.1818ZM191.355 111V41.1818H204.003V100.398H234.753V111H191.355Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.457 402.335C144.29 402.335 140.645 400.772 137.52 397.647C134.395 394.522 132.832 390.876 132.832 386.71V251.293C132.832 247.126 134.395 243.48 137.52 240.355C140.645 237.23 144.29 235.668 148.457 235.668H325.54C329.707 235.668 333.353 237.23 336.478 240.355C339.603 243.48 341.165 247.126 341.165 251.293V386.71C341.165 390.876 339.603 394.522 336.478 397.647C333.353 400.772 329.707 402.335 325.54 402.335H148.457ZM236.999 323.689L148.457 265.616V386.71H325.54V265.616L236.999 323.689ZM236.999 308.064L324.499 251.293H149.759L236.999 308.064ZM148.457 265.616V251.293V386.71V265.616Z",
    fill: "#0F753C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_934",
    x: 34.043,
    y: 41.1836,
    width: 204.711,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_934",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEml);
export default __webpack_public_path__ + "static/media/eml.37ee2edf5b910470915d0b6349dd7d44.svg";
export { ForwardRef as ReactComponent };